// @flow
import PromptRouterCustom from './prompt-router-custom';

export default PromptRouterCustom;
